module.exports = __webpack_public_path__ + "img/gallery-6.1bb4e229.jpg";